import React, { useState } from 'react';
import './css/App.css';
import AppRouter from './router';

// Main App Component
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('isLoggedIn') === 'true'
  );

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token');
    setIsAuthenticated(false);
  };

  return (
    <div className="App">
      <AppRouter isAuthenticated={isAuthenticated} onLogout={handleLogout} />
    </div>
  );
}

export default App;
